"use strict";

const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");
const logo = require("src/foundations/logos/Swift_Logo_RGB_Dark_Green.svg");

// // load font via webpack asset/resource
// require("src/tokens/index.css");

class Header extends HTMLElement {
    constructor(template) {
        super(template);

        this.root = this.attachShadow({ mode: "open" });

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.header = this.root.querySelector("header");

        this.icon = this.root.querySelector("img");
        this.icon.src = logo;
        this.links = this.root.querySelector(".links");

        this.initSlots();

    }


    initSlots () {
        const tabsSlot = this.querySelector("[slot=tabs]");
        if (tabsSlot) {
            tabsSlot.removeAttribute("slot");
            this.header.appendChild(tabsSlot);
        }
        const titleSlot = this.querySelector("[slot=title]");
        if (titleSlot) {
            titleSlot.removeAttribute("slot");
            this.header.appendChild(titleSlot);
        }
        const links = this.querySelectorAll("[slot=link]");
        for (const link of links) {
            link.style.visibility = "";
            this.links.appendChild(link);
        }
    }


    connectedCallback() {

        // forward tabs change event
        this.tabs = this.header.querySelector("swiftref-tabs");
        if (this.tabs) {
            this.tabs.addEventListener("change_tab", function (event) {
                this.dispatchEvent(new CustomEvent("change_tab", {
                    detail: event.detail
                }));
            }.bind(this));
        }

    }
}

window.customElements.define("swiftref-header", Header);

module.exports = Header;
